import React from "react";

const Panels = ({ translate }) => {
  return (
    <div className="content active">
      <h2>{translate("hostingPlans")}</h2>
      <div className="panels-table">
        <table>
          <thead>
            <tr>
              <th>{translate("plan")}</th>
              <th>{translate("price")}</th>
              <th>{translate("features")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> بسته شروع ۱۷۵,۰۰۰ تومان </td>
              <td> قیمت سالانه: ۲,۱۰۰,۰۰۰ تومان  <p> <a href="https://zarinp.al/690331">خرید</a></p> </td>
            </tr>
            <tr>
              <td>بسته استاندارد ۳۷۵,۰۰۰ تومان  </td>
              <td>قیمت سالانه: ۴,۵۰۰,۰۰۰ تومان  <p> <a href="https://zarinp.al/710407">خرید</a></p></td>
            </tr>
            <tr>
              <td>بسته حرفه‌ای ۹۰۰,۰۰۰ تومان</td>
              <td>قیمت: ۱۰,۸۰۰,۰۰۰ تومان <p> <a href="https://zarinp.al/710410">خرید</a></p></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Panels;